import React from 'react';
import { NextSeo } from 'next-seo';

export default ({ title, description }) => (
  <NextSeo
    title={title}
    description={description}
  />
);
